import { useState } from "react";
import image from "../../../Assets/host_charger/grocery_and_retail-c.webp"

const TABS = [
    {
        key: "allocated",
        title: "Allocated Charging",
        description: "If you offer residents dedicated parking spaces with a shared meter, assigned charging is best for your property",
        points: [
            "Assign charging stations to residents",
            "Easy Access Control Via RFID Card",
            "Allow property owner to handle installation and maintenance",
        ],
        icon: image
    },
    {
        key: "community",
        title: "Community Charging",
        description: "Ideal for properties with shared access. Community charging is accessible to all residents as needed",
        points: [
            "Shared stations accessible to all residents",
            "Usage tracking and billing systems",
            "Requires property-wide planning",
        ],
        icon: image,
    },
    {
        key: "mixed",
        title: "Mixed-Use Charging",
        description: "Perfect for properties with both personal and public spaces, offering flexibility and access to all users",
        points: [
            "Combine private and shared stations",
            "Supports residents and guests",
            "Requires balanced infrastructure",
        ],
        icon: image,
    },
];

export default function ChargingSolutionsTabs() {
    const [activeTab, setActiveTab] = useState("allocated");

    const activeContent = TABS.find((tab) => tab.key === activeTab);

    return (
        <div className="containers-min mx-auto px-4 py-12">
            <div className="text-center">
                <h3 className="text-center font-gilroy">
                    Charging Solutions That <br /> <b> Fit Every Scenario </b>
                </h3>
                <p className="leading-normal font-poppins text-center px-5 pt-4 text-base md:text-xl lg:text-2xl">
                    No matter your parking layout, providing easy, convenient, and well-managed EV charging is within reach
                </p>
            </div>

            <div className="flex justify-center space-x-2 bg-gray-200 rounded-full p-1 mt-12 px-4 py-3 ">
                {TABS.map((tab, index) => (
                    <div key={tab.key} className="flex items-center">
                        <button
                            onClick={() => setActiveTab(tab.key)}
                            className={`px-4 py-3 rounded-full text-lg font-medium transition font-poppins ${activeTab === tab.key ? "bg-white text-black shadow" : "text-gray-600"
                                }`}
                        >
                            {tab.title}
                        </button>
                        {index < TABS.length - 1 && (
                            <span className="text-gray-400 mx-2 select-none">|</span>
                        )}
                    </div>
                ))}
            </div>

            <div className="bg-gray-100 rounded-xl p-6 flex flex-col md:flex-row gap-6 sm:gap-10 items-center sm:items-start mt-2">                
                <div className="flex-shrink-0 w-[400px] h-[300px]">
                    <img
                        src={activeContent.icon}
                        alt={activeContent.title}
                        className="w-full h-full object-contain"
                    />
                </div>
                
                <div className="text-center md:text-left">
                    <h3 className="md:py-3 text-3xl font-bold font-gilroy ">{activeContent.title}</h3>
                    <p className="leading-normal font-poppins text-start px-5 mb-3">{activeContent.description}</p>

                    <ul className="list-disc list-inside space-y-2">
                        {activeContent.points.map((point, idx) => (
                            <li key={idx} className="leading-normal font-poppins text-start px-5 text-lg">{point}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
